'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  components: {
    DofRichTextText: require('./dof-rich-text-text.vue'),
    DofRichTextLink: require('./dof-rich-text-link.vue'),
    DofRichTextIcon: require('./dof-rich-text-icon.vue'),
    DofRichTextTag: require('./dof-rich-text-tag.vue')
  },
  props: {
    configList: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    hasTextMargin: {
      type: Boolean,
      default: true
    },
    textStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isNotEmptyArray: function isNotEmptyArray() {
      var obj = this.configList;
      return obj && obj.length > 0 && Array.isArray(obj) && typeof obj !== 'undefined';
    },
    isString: function isString() {
      return typeof this.configList === 'string';
    },
    outputTextStyle: function outputTextStyle() {
      var textStyle = this.textStyle;

      return _extends({}, textStyle);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-rich-text/index.vue
// module id = 378
// module chunks = 0 1